import debug from 'debug';
import { STORAGE_KEY } from '@/constant/constant';
import { setLocal } from '@/utils/storage';

const log = debug('cartsee:shopify:newsletter');

export const shopifyNewsletter = () => {
  log('shopifyNewsletter');
  // 监听所有表单提交
  document.addEventListener('submit', function (event) {
    log('Newsletter submit event');
    try {
      const form = event.target as HTMLFormElement;

      // 检查是否为newsletter表单
      if (form.action.includes('/contact') || form.querySelector('input[name="contact[tags]"]')) {
        const email = (form.querySelector('input[type="email"]') as HTMLInputElement).value;
        log('Newsletter subscription:', email);
        setLocal(STORAGE_KEY.NEWSLETTER_EMAIL, email);
      }
    } catch (error) {
      log('Newsletter form submission error:', error);
    }
  });
};
